import { Minus, Plus } from "lucide-mui"
import React from "react"

import i18n from "@/i18n"

type PartySizeStepperProps = {
  value: number | null
  max: number
  onChange: (value: number | null) => void
}

const BOX_STYLES =
  "flex h-[40px] w-[40px] shrink-0 items-center justify-center rounded-[6px] border-[0.5px] border-[#e5e6ec] bg-white text-[#374151] transition-colors enabled:hover:bg-[#f4f6f8] disabled:cursor-not-allowed disabled:opacity-40"

const PartySizeStepper: React.FC<PartySizeStepperProps> = ({ value, max, onChange }) => {
  const canDecrease = value !== null
  const canIncrease = value === null || value < max

  const handleDecrease = () => {
    if (value === null) return
    onChange(value <= 1 ? null : value - 1)
  }

  const handleIncrease = () => {
    if (value === null) {
      onChange(1)
      return
    }
    onChange(Math.min(value + 1, max))
  }

  return (
    <div className="flex items-center gap-2" data-testid="public-venue-mobile-booking-party-stepper">
      <button
        type="button"
        onClick={handleDecrease}
        disabled={!canDecrease}
        className={BOX_STYLES}
        aria-label={i18n.t("app.public.venue.mobile_booking.decrease_party")}
        data-testid="public-venue-mobile-booking-party-decrease"
      >
        <Minus className="h-4 w-4" />
      </button>

      <div
        className="flex h-[40px] flex-1 items-center justify-center rounded-[6px] border-[0.5px] border-[#e5e6ec] bg-white text-[16px] font-medium text-[#2596fa]"
        aria-live="polite"
        data-testid="public-venue-mobile-booking-party-value"
      >
        {value ?? ""}
      </div>

      <button
        type="button"
        onClick={handleIncrease}
        disabled={!canIncrease}
        className={BOX_STYLES}
        aria-label={i18n.t("app.public.venue.mobile_booking.increase_party")}
        data-testid="public-venue-mobile-booking-party-increase"
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  )
}

export default PartySizeStepper
